import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { debounce } from '~src/lib/helpers';
import userEvents from '.';

// Debouncing `trackPageView` to avoid triggering it multiple times
// when page rerenders and settles down
const trackPageView = userEvents.trackPageView;
const debouncedEmit = debounce(trackPageView, 1000);

const PageViewEmitter = ({ beacon }) => {
  const location = useLocation();
  const { user, retailer } = useSelector(({ userReducer }) => ({
    user: userReducer.user,
    retailer:
      userReducer.user?.retailerIdToRetailerInfo[userReducer.user?.retailerId],
  }));

  const userRef = useRef(user);
  userRef.current = user;

  const retailerRef = useRef(retailer);
  retailerRef.current = retailer;

  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  // Page view tracking
  useEffect(() => {
    if (!user || !retailer) return;

    debouncedEmit(
      userRef.current,
      retailerRef.current,
      pathRef.current,
      beacon,
    );
  }, [user, retailer, location, beacon]);

  // Button click tracking
  useEffect(() => {
    const handleClick = event =>
      userEvents.trackButtonClick(
        userRef.current,
        retailerRef.current,
        pathRef.current,
        event,
      );
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
};

export default PageViewEmitter;
